<div class="container coustom_container">
  <div class="row">
    <div class="col-12 ">
      <span class="title_header_bar">Cancellation Requests </span>
    </div>
  </div>
  <div class="card card_content">
    <form [formGroup]="searchform">

      <div class="row d-flex justify-content-center align-items-center flex-wrap grid-margin"
        style="margin-bottom: 1rem !important;">
        <div class="col-md-3">
          <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
            <i class="fa fa-refresh"></i> Refresh
          </button> -->
          <app-button (refreshClicked)="clearFilter()"></app-button>

          <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
            <i class="fa fa-file-excel"></i> Export
          </button>
        </div>
        <div class="col-md-4 padd-right-file" style="display: flex;">
          <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
            <mat-label>Search</mat-label>
            <div class="search-input-container">
              <input formControlName="searchQuery"
                placeholder="Enter Customer Number / Application / Name / Contact Number" id="search" matInput
                type="text" #searchInput>
            </div>
          </mat-form-field>
          <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
            (click)="search()">
            <mat-icon style="color: white;"> search</mat-icon>
          </button>
        </div>
        <div class="col-3 ml-5" [hidden]="sessionDataString.roletype ==roletype.Technician">
          <button type="button" class="btn btn-primary mr-3  d-flex" (click)="filtershow = !filtershow">
            <ng-container *ngIf="!filtershow">
              <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
            </ng-container>
            <ng-container *ngIf="filtershow">
              <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
            </ng-container>
            <span class="ml-2">Advanced search</span>
          </button>
        </div>
      </div>
    </form>
    <div [@detailExpand]="filtershow ? 'expanded' : 'collapsed'" style="overflow: hidden;">
      <hr>
      <div class="subtitle_header ml-5">Advanced Search</div>
      <form [formGroup]="form" class="container mx-5">
        <div class="row">
          <div class="col-xl-6 mt-4">
            <mat-form-field appearance="fill" hideRequiredMarker>
              <mat-label>Service Provider</mat-label>
              <mat-select class="scrollbarcs" formControlName="serviceProviderId" placeholder="Select Primary Product ">
                <mat-select-filter [displayMember]="'value'" [array]="productcategory"
                  (filteredReturn)="filteredList = $event"></mat-select-filter>
                <mat-option *ngFor="let item of filteredList" [value]="item.key" style="overflow-y: scroll !important;">
                  {{item.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xl-6 mt-4">
            <mat-form-field appearance="fill" hideRequiredMarker>
              <mat-label>Application Status</mat-label>
              <mat-select class="scrollbarcs" formControlName="changeRequestStatus"
                placeholder="Select Application Status ">
                <mat-select-filter [displayMember]="'value'" [array]="applicationstatus"
                  (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                  style="overflow-y: scroll !important;">
                  {{item.value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>Effective Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" formControlName="effectiveStartDate" autocomplete="off"
                placeholder="Select Start Date" class="custom-input-border" (click)="startDatePicker.open()"
                (dateChange)="onDateChange($event, 'effectiveStartDate')" readonly>
              <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>Effective End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" formControlName="effectiveEndDate" autocomplete="off"
                placeholder="Select End Date" class="custom-input-border" (click)="endDatePicker.open()"
                (dateChange)="onDateChange($event, 'effectiveEndDate')" readonly>
              <mat-datepicker-toggle matSuffix [for]="endDatePicker" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>Admin Approved Effective Start Date</mat-label>
              <input matInput [matDatepicker]="adminStartDatePicker" formControlName="adminApprovedEffectiveStartDate"
                autocomplete="off" placeholder="Select From Date" class="custom-input-border"
                (click)="adminStartDatePicker.open()"
                (dateChange)="onDateChange($event, 'adminApprovedEffectiveStartDate')" readonly>
              <mat-datepicker-toggle matSuffix [for]="adminStartDatePicker" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #adminStartDatePicker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="col-xl-6 mt-4">
            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
              <mat-label>Admin Approved Effective End Date</mat-label>
              <input matInput [matDatepicker]="adminEndDatePicker" formControlName="adminApprovedEffectiveEndDate"
                autocomplete="off" placeholder="Select To Date" class="custom-input-border"
                (click)="adminEndDatePicker.open()" (dateChange)="onDateChange($event, 'adminApprovedEffectiveEndDate')"
                readonly>
              <mat-datepicker-toggle matSuffix [for]="adminEndDatePicker" style="color:black;">
                <button mat-icon-button>
                  <mat-icon>event</mat-icon>
                </button>
              </mat-datepicker-toggle>
              <mat-datepicker #adminEndDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>


        <div class="d-flex justify-content-center button-style mt-3">
          <button class="btn reset_btn mb-3 mr-3" type="button" (click)="clearFilter()" matButton><i
              class="fa fa-refresh"></i> Reset</button>
          <button class="btn btn-secondary mb-3" type="submit" (click)="filter()" matButton><i class="fa fa-search"></i>
            Search</button>
        </div>

      </form>
    </div>
    <div class="table-responsive table-container mt-2">
      <mat-table #table [dataSource]="dataSource" class="mat-table">

        <ng-container matColumnDef="CancellationNo">
          <mat-header-cell *matHeaderCellDef style="text-align: center;">Cancellation No</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 8%;">
            <p class="text-truncate txtalign" style="cursor: pointer;;"
              [ngStyle]="{'color': dataField.isAddressChange ? 'orange' : '#9B02DB'}" (click)="view(dataField)"><b>
                {{dataField.serviceReferencenumber}}</b></p>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Type">
          <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="padding:0; margin:0; width:3%">
            <p class="text-truncate txtalign">{{dataField.type}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Customer">
          <mat-header-cell *matHeaderCellDef> Customer</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 4%;">
            <p class="text-truncate txtalign">{{dataField.customerName}} </p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CustomerNo">
          <mat-header-cell *matHeaderCellDef>Customer No</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 2%; ">
            <p class="text-truncate txtalign">{{dataField.customerReferenceNumber}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ServiceProvider">
          <mat-header-cell *matHeaderCellDef>Service Provider</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 5%;">
            <p class="text-truncate txtalign">{{dataField.serviceProvider}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CurrentService">
          <mat-header-cell *matHeaderCellDef>Current Service</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 10%;">
            <p class="text-truncate txtalign">{{dataField.aliasName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CreatedOn">
          <mat-header-cell *matHeaderCellDef>CreatedOn</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 7%;">
            <p class="text-truncate txtalign">{{dataField.serviceRequestedOnTs | date:'MM/dd/yyyy H:mm a'}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RequestedDate">
          <mat-header-cell *matHeaderCellDef>Requested Date</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 7%;">
            <p class="text-truncate txtalign">{{dataField.requestedCancellationDate}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="EffectiveOn">
          <mat-header-cell *matHeaderCellDef>Effective On</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 7%;">
            <p class="text-truncate txtalign">{{dataField.approveCancellationDate}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 13%;">
            <p class="text-truncate txtalign py-2" [ngClass]="getStatusClass(dataField.changeRequestStatus)">
              {{dataField.changeRequestStatusName}}</p>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 8%;">
            <div class="d-flex flex-wrap justify-content-center align-items-center" style="gap: 10px;">

              <div class="icon-wrapper"
                *ngIf="dataField.changeRequestStatus == ChangeRequestStatusType.NewCancellationRequest && !dataField.isAcknowledged">
                <i class="fas fa-check-square" title="Acknowledge of cancellation"
                  style="cursor: pointer; font-size: 18px; color: #9B02DB;" (click)="acknowledgment(dataField)"></i>
              </div>

              <div class="icon-wrapper" *ngIf="dataField.isAcknowledged">
                <i class="fas fa-check-square" title="Acknowledge of cancellation"
                  style="cursor: pointer; font-size: 18px; color: blue;" (click)="acknowledgment(dataField)"></i>
              </div>

              <div class="icon-wrapper"
                *ngIf="dataField.isAcknowledged || dataField.changeRequestStatus == ChangeRequestStatusType.CancellationAPIFaild && dataField.changeRequestStatus == ChangeRequestStatusType.NewCancellationRequest">
                <i class="fa fa-check" title="approve" style="cursor: pointer; font-size: 18px; color: green;"
                  (click)="approve(dataField,false)"></i>
              </div>

            <div class="icon-wrapper"
              *ngIf="dataField.isAcknowledged && dataField.changeRequestStatus == ChangeRequestStatusType.CancellationAPIFaild && sessionDataString.roleId == roletype.SuperAdmin">
              <i class="fa fa-check" title="manual_approve" style="cursor: pointer; font-size: 18px; color: #9B02DB;"
                (click)="approve(dataField,false,true)"></i>
            </div>

            <!-- <div class="icon-wrapper"
              *ngIf="dataField.isAcknowledged && dataField.changeRequestStatus == ChangeRequestStatusType.NewCancellationRequest">
              <i class="fa fa-ban" title="reject" style="cursor: pointer; font-size: 18px; color: red;"
                (click)="reject(dataField)"></i>
            </div> -->

              <div class="icon-wrapper"
                *ngIf="dataField.changeRequestStatus == ChangeRequestStatusType.CancellationPending || dataField.changeRequestStatus == ChangeRequestStatusType.CancellationWithNotice">
                <i class="fa fa-pen-to-square" title="amend" style="cursor: pointer; font-size: 18px; color: blue;"
                  (click)="approve(dataField,true)"></i>
              </div>

             <div class="icon-wrapper"
                *ngIf="(dataField.isAcknowledged && dataField.changeRequestStatus == ChangeRequestStatusType.NewCancellationRequest && !dataField.hasMoveAddress)
                    || (!dataField.hasMoveAddress && (dataField.changeRequestStatus == ChangeRequestStatusType.CancellationPending || dataField.changeRequestStatus == ChangeRequestStatusType.CancellationWithNotice))">
                <i class="fa fa-ban" title="reject" style="cursor: pointer; font-size: 18px; color: red;"
                  (click)="reject(dataField)"></i>
              </div>

              <div class="icon-wrapper"
                *ngIf="dataField.changeRequestStatus == ChangeRequestStatusType.CancellationRejected">
                <i class="fa fa-close" title="Move to Cancellation Completed"
                  style="cursor: pointer; font-size: 18px; color: red;"
                  (click)="movetoCancellationComplete(dataField)"></i>
              </div>


            </div>
          </mat-cell>
        </ng-container>





        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
        </mat-row>
      </mat-table>
      <div *ngIf="data?.length == 0" class="no-data-message">
        <p>No data found</p>
      </div>
    </div>
    <div class="table_pagenation">
      <mat-paginator #paginator [length]="dataSource?.filteredData?.length || 0" [pageIndex]="0" [pageSize]="50"
        [pageSizeOptions]="[50, 100]">
      </mat-paginator>
    </div>
  </div>
</div>